import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const CallBackOnHover = ({ callback, children, once }) => {
  const wasHovered = useRef(false);

  function onMouseEnter() {
    if (!once) {
      callback();
    } else if (once && !wasHovered.current) {
      wasHovered.current = true;
      callback();
    }
  }

  return <span onMouseEnter={onMouseEnter}>{children}</span>;
};

CallBackOnHover.propTypes = {
  children: PropTypes.node.isRequired,
  callback: PropTypes.func.isRequired,
  once: PropTypes.bool,
};

CallBackOnHover.defaultProps = {
  once: false,
};

export default CallBackOnHover;
